<template>
    <card-collapsable :title="prismsTitle" start-visible>
        <b-row align-h="center">
            <b-col xl="8" cols="12">
                <b-form-group label="Seleção de prismas">
                    <rts-legend />
                    <multi-selector
                        :available="available"
                        :selected="selected"
                        :disabled="loading"
                        @select="select"
                        @deselect="deselect"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col xl="8" cols="12">
                <date-range-selector
                    ref="dateSelector"
                    label="Intervalo de tempo"
                    :disabled="loading"
                    @change="$emit('change', 'dateRange')"
                />
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col xl="8" cols="12">
                <b-form-group label="Variável de análise">
                    <b-form-select
                        v-model="analysisVariable"
                        :options="analysisVariableOptions"
                        :disabled="loading"
                        @change="$emit('change', 'analysisVariable')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col xl="8" cols="12">
                <b-form-group label="Dados de interesse">
                    <b-form-checkbox-group
                        v-model="requestedDataType"
                        :options="requestedDataTypeOptions"
                        :disabled="loading"
                        switches
                        @change="$emit('change', 'requestedDataType')"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="text-center">
                <b-overlay
                    :show="loading"
                    class="d-inline-block"
                    variant="white"
                    :rounded="true"
                    spinner-small
                >
                    <b-button
                        class="pl-1"
                        :disabled="!canUpdate || loading"
                        @click="update"
                    >
                        <i class="fas fa-sm fa-sync-alt mx-1" />
                        Atualizar gráfico
                    </b-button>
                </b-overlay>
            </b-col>
        </b-row>
    </card-collapsable>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CardCollapsable from "@/components/CardCollapsable";
import DateRangeSelector from "@/components/DateRangeSelector";
import { PRISMS_Y_AXES, Sources } from "@/modules/common/settings";
import MultiSelector from "@/components/MultiSelector";
import RtsLegend from "./RtsLegend";

const analysisVariables = Object.keys(PRISMS_Y_AXES).map(key => ({
    text: PRISMS_Y_AXES[key].label,
    value: key
}));

export default {
    name: "PrismFilters",
    components: {
        CardCollapsable,
        MultiSelector,
        DateRangeSelector,
        RtsLegend
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            analysisVariable: null,
            requestedDataType: ["measure"]
        };
    },
    computed: {
        ...mapState("common/prisms", {
            selected: "selectedPoints"
        }),
        ...mapGetters("common/prisms", {
            available: "availablePoints"
        }),
        ...mapState("common", ["source"]),
        canUpdate() {
            if (
                this.selected.length === 0 ||
                this.requestedDataType.length === 0
            ) {
                return false;
            }

            return this.analysisVariable !== null;
        }
    },
    created() {
        this.analysisVariableOptions = [
            {
                text: "Selecione uma variável de análise.",
                value: null
            },
            ...analysisVariables
        ];
        this.requestedDataTypeOptions = [
            {
                text: "Medição",
                value: "measure"
            },
            {
                text: "Simulação",
                value: "simulation"
            },
            {
                text: "Cota montante",
                value: "quota_flux"
            }
        ];
        this.prismsTitle = "Dados de prismas";

        //  handle julho 14 virtual prisms
        if (this.source === Sources.JULHO_14) {
            this.prismsTitle = `${this.prismsTitle} virtuais`;
            // remove measures
            this.requestedDataTypeOptions.splice(0, 1);
            this.requestedDataType = ["simulation"];
        }
    },
    methods: {
        select(data) {
            this.$store.dispatch("common/prisms/selectPoints", data);
            this.$emit("change", "points");
        },
        deselect(data) {
            this.$store.dispatch("common/prisms/deselectPoints", data);
            this.$emit("change", "points");
        },
        requestedDataTypeAsObject() {
            const dataTypeObj = {};
            for (const dataType of this.requestedDataTypeOptions) {
                dataTypeObj[dataType.value] = this.requestedDataType.includes(
                    dataType.value
                );
            }
            return dataTypeObj;
        },
        update() {
            const { startDate, endDate } = this.$refs.dateSelector.value;

            this.$emit("update", {
                pointIds: this.selected.map(item => item.id),
                analysisVariable: this.analysisVariable,
                requestedDataType: this.requestedDataTypeAsObject(),
                startDate,
                endDate
            });
        }
    }
};
</script>
